
import "../css/vehicle.css";
import React, { useEffect, useState } from "react";
import Logo from "../assets/infraLogo.jpg";
import axios from "axios";

const API_BASE =
  import.meta.env?.VITE_API_BASE ||
  process.env.REACT_APP_API_BASE ||
  "https://rfs2.infraconsoft.net.in/api";

const API_ORIGIN = API_BASE.replace(/\/api\/?$/, "");


const InwardPrintPage = () => {
    const [data, setData] = useState([]);
    const branch = localStorage.getItem("branch");
     const [loading, setLoading] = useState(false);

      const [site, setSite] = useState({
    ok: true,
    name: "Infraconsoft",
    logo: null,
    address: "",
    email: "",
    phone: "",
    _ts: 0,
  });

  // Fetch site/company info
  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const res = await axios.get(`${API_BASE}/siteinfo`);
        const s = res?.data || {};
        // ensure absolute logo URL if server ever returns relative
        let logo = s.logo || null;
        if (logo && !/^https?:\/\//i.test(logo)) {
          if (!logo.startsWith("/")) logo = `/${logo}`;
          logo = `${API_ORIGIN}${logo}`;
        }
        if (!ignore) {
          setSite({
            ok: !!s.ok,
            name: s.name || "Infraconsoft",
            logo,
            address: s.address || "",
            email: s.email || "",
            phone: s.phone || "",
            _ts: Date.now(),
          });
        }
      } catch (e) {
        // keep defaults on failure
        console.error("Failed to load /siteinfo", e);
      }
    })();
    return () => {
      ignore = true;
    };
  }, []);



    useEffect(() => {
        fetchData();
      }, [branch]);
    
      const fetchData = async () => {
        setLoading(true);
        try {
          const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/stnInwardBill_report?branch=${branch}`);
          // console.log("API Response:", response.data.stnInwardReport);
          setData(response.data.stnInwardReport);
        } catch (error) {
          console.error("Error fetching purchaseOrderList:", error);
        } finally {
          setLoading(false);
        }
      };

       const logoSrc = site.logo ? `${site.logo}${site._ts ? `?v=${site._ts}` : ""}` : Logo;
    
  return (
    <div className="inward-container">
      <div className="prPrint-header">
        <img src={logoSrc} alt={`${site.name} Logo`} className="prPrint-logo" />
        <div className="prPrint-company-details">
          <h2 style={{ textTransform: "uppercase" }}>{site.name || "Infraconsoft"}</h2>
          {site.address && <p>{site.address}</p>}
          {(site.phone || site.email) && (
            <p>
              {site.phone && <span>Ph: {site.phone}</span>}
              {site.phone && site.email && <span> | </span>}
              {site.email && <span>Email: {site.email}</span>}
            </p>
          )}
        </div>
      </div>

      <table className="inward-table">
  <thead>
    <tr>
      <th>STN No</th>
      <th>Item Code</th>
      <th>Branch Name</th>
      <th>Date</th>
      <th>Issued Quantity</th>
      <th>Price</th>
    </tr>
  </thead>
  <tbody>
    {loading ? (
      <tr>
        <td colSpan="6" className="inward-loading-text">Loading data, please wait...</td>
      </tr>
    ) : data.length > 0 ? (
      // Grouping by Header Number
      Object.values(
        data.reduce((acc, item) => {
          const headerNo = item.sfIssuesHeader_number;
          if (!acc[headerNo]) {
            acc[headerNo] = { header: item, details: [] };
          }
          acc[headerNo].details.push(item);
          return acc;
        }, {})
      ).map((group, i) => (
        <React.Fragment key={i}>
          {/* STN Header Row */}
          <tr className="inward-header-row">
            <td colSpan="6" className="inward-header-title">
              STN No : {group.header.sfIssuesHeader_number}
            </td>
          </tr>
          {/* Detail Rows */}
          {group.details.map((detail, index) => (
            <tr key={index} className="inward-detail-row">
              <td></td>
              <td>{detail.sfissuesDetail_itemCode}</td>
              <td>{detail.branchCode}</td>
              <td>{new Date(detail.logoutTime).toLocaleDateString()}</td>
              <td>{detail.sfissuesDetail_issuedQuantity}</td>
              <td>{detail.sfIssuesDetail_price}</td>
            </tr>
          ))}
        </React.Fragment>
      ))
    ) : (
      <tr>
        <td colSpan="6">No Data Available</td>
      </tr>
    )}
  </tbody>
</table>

      <div className="inward-print">
        <button onClick={() => window.print()}>🖨️ Print</button>
      </div>
    </div>
  );
};

export default InwardPrintPage;
